import request from "./request.js";

export default {
  // 登录
  getIdolList: (data) => {
    return request({
      url: "api/admin/idol/showIdolList",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
};
